<template>
  <div>
    <label
      :class="`v-label v-label--active ${$vuetify.theme.dark ? 'theme--dark' : 'theme--light'}`"
      style="font-size: 12px"
    >{{ label }}</label>
    <v-input
      :hint="hint"
      :hide-details="hint===null"
      :class="[{'pb-2': hint===null}]"
      persistent-hint
    >
      <div class="w-100 d-flex mt-1 justify-space-between">
        <template v-for="i in 5">
          <v-btn
            :key="i"
            class="party-size-button"
            :class="`${$vuetify.theme.dark ? 'black--text' : 'white--text'}`"
            color="primary"
            :depressed="i === partySize"
            :outlined="i !== partySize"
            small
            @click="partySize = i"
          >
            {{ i }}
          </v-btn>
        </template>
        <!-- Hacked v-select to look just like a button -->
        <v-select
          v-model="partySize"
          class="buttonized-select"
          :items="partySizes"
          :append-icon="null"
          hide-details
          :menu-props="{ maxHeight: '500px', offsetY: true, contentClass: 'buttonized-select-menu' }"
          height="28"
        >
          <template #selection>
            <v-btn
              small
              block
              :depressed="partySize > 5"
              :outlined="partySize <= 5"
              color="primary"
            >
              {{ $t('label.more') }}{{ otherPartySizeButtonText }}
            </v-btn>
          </template>
        </v-select>
      </div>
    </v-input>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'PartySizePicker',
  props: {
    value: { type: Number, required: true },
    label: { type: String, required: false, default: '' },
    hint: { type: String, required: false, default: null },
  },
  data() {
    return {
      partySize: this.value,
      partySizes: [...new Array(501)].map((e, i) => (
        { value: i, text: this.$i18n.t('label.x_persons', [i]), disabled: i <= 5 })),
    };
  },
  computed: {
    otherPartySizeButtonText(): string {
      return this.partySize > 5 ? `: ${this.partySize}` : '';
    },
  },
  watch: {
    value() {
      this.partySize = this.value;
    },
    partySize() {
      if (this.partySize === this.value) return;
      this.$emit('input', this.partySize);
    },
  },
  methods: { },
});
</script>

<style scoped>

  .party-size-button ::v-deep(.v-btn__content) {
    font-size: 0.85rem!important;
  }

  .buttonized-select {
    margin-top: 0px;
    padding-top: 0px;
    max-width: 100px;
  }

  .buttonized-select ::v-deep(.v-btn) {
    padding: 0 9.5px
  }

  .buttonized-select ::v-deep(.v-input__slot::before), .buttonized-select ::v-deep(.v-input__slot::after)  {
    border: 0px !important;
  }

  .buttonized-select-menu .v-list ::v-deep(.v-list-item.v-list-item--disabled) {
    display: none;
  }

</style>
